import { AppBar, Box, Toolbar, Typography, useTheme, } from '@mui/material';
export default function GuestTopbar() {
    const theme = useTheme();
    return (<Box sx={{ zIndex: 101 }}>
        <AppBar elevation={5} sx={{ backgroundColor: 'common.white' }}>
            <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', minHeight: { xs: '70px !important', sm: '75px !important' } }}>
                <Box display="flex" alignItems="center" sx={{ flexGrow: 1, cursor: "pointer" }} >
                    <Box>
                        <img src="/images/logo/camp-logo.jpg" alt="Government Logo" style={{ width: 48, height: 50 }} />
                    </Box>
                    <Box sx={{ borderRight: { xs: "none", md: `2px solid ${theme.palette.primary.main}` }, height: "50px", mx: 2 }} />
                    <Box sx={{ maxWidth: "500px", flexShrink: 1, p: { xs: 1, md: 1 } }}>
                        <Typography variant="h6" fontWeight="bold" color={theme.palette.primary.main} sx={{ fontSize: { xs: "1rem", md: "1.5rem" } }}> Chief Minister's Community Health Camp</Typography>
                        {/* <Typography variant="body2" color={theme.palette.text.secondary} sx={{ display: { xs: "0.1rem", md: "block" } }}>    Healthcare at Your Doorstep – Don’t Miss Out!</Typography> */}
                    </Box>
                </Box>
                <Box display="flex" alignItems="center">
                    <img src="/images/guest/guest_Topbar-logo.png" alt="Government Logo" style={{ width: 56, height: 56 }} />
                </Box>
            </Toolbar>
        </AppBar>
    </Box>);
}